"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedWebsitePropertyList = instanceOfPaginatedWebsitePropertyList;
exports.PaginatedWebsitePropertyListFromJSON = PaginatedWebsitePropertyListFromJSON;
exports.PaginatedWebsitePropertyListFromJSONTyped = PaginatedWebsitePropertyListFromJSONTyped;
exports.PaginatedWebsitePropertyListToJSON = PaginatedWebsitePropertyListToJSON;
exports.PaginatedWebsitePropertyListToJSONTyped = PaginatedWebsitePropertyListToJSONTyped;
const websiteProperty_1 = require("./websiteProperty");
/**
 * Check if a given object implements the PaginatedWebsitePropertyList interface.
 */
function instanceOfPaginatedWebsitePropertyList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedWebsitePropertyListFromJSON(json) {
    return PaginatedWebsitePropertyListFromJSONTyped(json, false);
}
function PaginatedWebsitePropertyListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(websiteProperty_1.WebsitePropertyFromJSON)),
    };
}
function PaginatedWebsitePropertyListToJSON(json) {
    return PaginatedWebsitePropertyListToJSONTyped(json, false);
}
function PaginatedWebsitePropertyListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(websiteProperty_1.WebsitePropertyToJSON)),
    };
}
//# sourceMappingURL=paginatedWebsitePropertyList.js.map